/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ScopesControllerBulkArchiveMutationRequest, ScopesControllerBulkArchiveMutationResponse, ScopesControllerBulkArchive400, ScopesControllerBulkArchive401 } from "../../models/scopesController/ScopesControllerBulkArchive";

function getScopesControllerBulkArchiveUrl() {
  const res = { method: 'PATCH', url: `/api/v1/scopes/bulk-archive` as const }  
  return res
}

/**
 * @description Archive or restore multiple project/folder scopes in a single call. Archiving cascades to descendant folders/files; restoring defaults to restoreScope=exact (only cascade-archived descendants come back). If a container and its nested items are both selected, nested items are deduplicated. Returns 200 if all items succeed, 207 Multi-Status if some items fail.
 * @summary Bulk archive or restore scopes
 * {@link /api/v1/scopes/bulk-archive}
 */
export async function scopesControllerBulkArchive(data: ScopesControllerBulkArchiveMutationRequest, config: Partial<RequestConfig<ScopesControllerBulkArchiveMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ScopesControllerBulkArchiveMutationResponse, ResponseErrorConfig<ScopesControllerBulkArchive400 | ScopesControllerBulkArchive401>, ScopesControllerBulkArchiveMutationRequest>({ method : "PATCH", url : getScopesControllerBulkArchiveUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}